<script>
  let { children, name = 'App' } = $props();
  let error = $state(null);
  let errorInfo = $state('');

  function handleError(e) {
    error = e?.error || e || new Error('Unknown error');
    errorInfo = error?.message || String(error);
    console.error(`[ErrorBoundary:${name}]`, error);
  }

  function reset() {
    error = null;
    errorInfo = '';
  }
</script>

<svelte:window onerror={handleError} />

{#if error}
  <div role="alert" class="error-boundary-fallback" style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;background:#1e1e1e;color:#d4d4d4;font-family:system-ui,sans-serif;padding:40px;text-align:center;">
    <div style="font-size:48px;margin-bottom:16px;">⚠️</div>
    <h2 style="margin:0 0 8px;font-size:18px;">Something went wrong in {name}</h2>
    <p style="margin:0 0 24px;color:#888;font-size:13px;max-width:400px;">{errorInfo}</p>
    <button onclick={reset} style="padding:10px 24px;background:#0e639c;color:#fff;border:none;border-radius:6px;cursor:pointer;font-size:14px;">Restart {name}</button>
  </div>
{:else}
  {@render children()}
{/if}
